"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
require("./HeaderComponent.scss");
const logo_webp_1 = __importDefault(require("../../assets/images/logo.webp"));
const HeaderComponent = ({ children }) => {
    const route = (0, react_router_1.useLocation)();
    const history = (0, react_router_1.useHistory)();
    return (react_1.default.createElement("div", { className: "HeaderComponentParent" },
        react_1.default.createElement("div", { className: "HeaderComponent" },
            react_1.default.createElement("div", { onClick: () => {
                    if (route.pathname === '/') {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                    else {
                        history.push('/');
                    }
                }, style: { cursor: 'pointer' }, className: "header-logo" },
                react_1.default.createElement("img", { src: logo_webp_1.default, alt: "" })),
            children)));
};
exports.default = HeaderComponent;
